<template>
  <div class="separator">
    <div class="line"></div>
    <span>{{ text }}</span>
    <div class="line"></div>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
  },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/colors.scss';
.separator {
  color: $grey;
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
}
.line {
  flex: 1;
  border-bottom: 1px solid $grey;
  height: 1px;
}
span {
  margin: 0 10px;
}
</style>
